/**
 * AI Settings - API接口
 */

import psHttp from '@patsnap/common-ps-http';
import { DRAFTING_URI } from '@/constants/base-url';
import type { AILanguageSetting } from './types';

const BASE_URL = `${DRAFTING_URI}/api/user/settings`;

/**
 * 获取AI输出语言设置
 * 如果用户未设置过，后端会返回根据region计算的默认值
 */
export function getAIOutputLanguage(): Promise<AILanguageSetting> {
    return psHttp({
        url: `${BASE_URL}/ai_output_language`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => data.data);
}

/**
 * 保存AI输出语言设置
 */
export function saveAIOutputLanguage(language: string): Promise<AILanguageSetting> {
    return psHttp({
        url: `${BASE_URL}/ai_output_language`,
        method: 'POST',
        data: { language },
        transformCode: true,
    }).then(({ data }) => data.data);
}
